import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "./Logo";
import { useAuth } from "../lib/auth";
import { Menu, X } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <nav
      className="bg-white border-b border-[#E2E8F0] sticky top-0 z-50"
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center" data-testid="navbar-logo-link">
          <Logo />
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <Link
            to="/#active-events"
            className="text-sm font-medium text-[#0F172A] hover:text-[#5B4CFF] transition-colors"
            data-testid="nav-events-link"
          >
            Events
          </Link>
          <Link
            to="/#how-it-works"
            className="text-sm font-medium text-[#0F172A] hover:text-[#5B4CFF] transition-colors"
            data-testid="nav-how-link"
          >
            How it works
          </Link>
          <Link
            to="/#benefits"
            className="text-sm font-medium text-[#0F172A] hover:text-[#5B4CFF] transition-colors"
            data-testid="nav-benefits-link"
          >
            Benefits
          </Link>
          <Link
            to="/#contact-section"
            className="text-sm font-medium text-[#0F172A] hover:text-[#5B4CFF] transition-colors"
            data-testid="nav-contact-link"
          >
            Contact
          </Link>
          {user ? (
            <div className="flex items-center gap-3">
              <Link
                to={user.role === "super_admin" ? "/admin" : "/organizer"}
                className="text-sm font-semibold text-[#0F172A] border border-[#E2E8F0] hover:border-[#5B4CFF] px-4 py-2 transition-colors"
                data-testid="nav-dashboard-link"
              >
                Dashboard
              </Link>
              <button
                onClick={handleLogout}
                className="text-sm font-medium text-[#475569] hover:text-[#0F172A] transition-colors"
                data-testid="nav-logout-btn"
              >
                Sign out
              </button>
            </div>
          ) : (
            <Link
              to="/login"
              className="text-sm font-semibold bg-[#5B4CFF] hover:bg-[#4a3dde] text-white px-5 py-2.5 transition-colors"
              data-testid="nav-signin-link"
            >
              Sign in
            </Link>
          )}
        </div>

        <button
          className="md:hidden p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#E2E8F0] bg-white" data-testid="nav-mobile-panel">
          <div className="px-4 py-4 flex flex-col gap-3">
            <Link to="/#active-events" onClick={() => setOpen(false)} className="text-sm font-medium text-[#0F172A]">Events</Link>
            <Link to="/#how-it-works" onClick={() => setOpen(false)} className="text-sm font-medium text-[#0F172A]">How it works</Link>
            <Link to="/#benefits" onClick={() => setOpen(false)} className="text-sm font-medium text-[#0F172A]">Benefits</Link>
            <Link to="/#contact-section" onClick={() => setOpen(false)} className="text-sm font-medium text-[#0F172A]">Contact</Link>
            {user ? (
              <>
                <Link to={user.role === "super_admin" ? "/admin" : "/organizer"} onClick={() => setOpen(false)} className="text-sm font-semibold text-[#5B4CFF]">Dashboard</Link>
                <button onClick={handleLogout} className="text-left text-sm font-medium text-[#475569]">Sign out</button>
              </>
            ) : (
              <Link to="/login" onClick={() => setOpen(false)} className="text-sm font-semibold bg-[#5B4CFF] text-white px-4 py-2 inline-block w-fit">Sign in</Link>
            )}
          </div>
        </div>
      )}
    </nav>
  );
}
